import Styles from './StreamsPurchase.module.scss';
import { useEffect, useState, useContext } from 'react';

// Module imports
import { Drawer, Typography } from '@mui/material';

// Components import.
import { AuthContext, useAPI } from 'components/lib';
import PurchaseCard from 'components/global/PurchaseCards/PurchaseCard';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { Checkout } from 'components/global/Checkout/Checkout';
import { Notification } from 'components/notifications/notification';


export const StreamsPurchase = (props) => {

    const [showCheckout, setShowCheckout] = useState(false)
    const [streams, setStreams] = useState([])
    const { data, loading } = useAPI('api/streams', 'GET');
    const authContext = useContext(AuthContext);
    const currencySymbol = authContext?.user?.currencySymbol || ''

    useEffect(() => {
        if (data) {
            setStreams(data);
        }
    }, [data]);

    return (
        <>
            <Notification call='streams' />
            <LoadingBackdrop isOpen={data?.loading} />
            <Typography
                variant="h6"
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '16px',
                    mb: '-15px',
                    color: 'rgb(0, 74, 173)',
                    justifyContent: 'space-between'
                }}
            >
                <BreadCrumbs
                    onClickPaths={['']}
                    crumbs={props.t('Streams.StreamsPurchase.breadcrumbs', { returnObjects: true })}
                />
            </Typography>

            <div className={Styles.CardContainer}>
                {streams.length > 0 && (
                    <div id='textBtnContainer' className={Styles.textBtnContainer}>
                        <span className={Styles.headContainer}>
                            <p className={Styles.headName}>{props.t('Streams.StreamsPurchase.link')}</p>
                            <span style={{ display: 'flex', alignItems: "center", gap: "1rem" }}>
                                <a href='/streams' className={Styles.myLabsLink}>{props.t('Streams.StreamsPurchase.button')}</a>
                                <button className={Styles.purchaseButton} onClick={() => { setShowCheckout(!showCheckout); }}>
                                    <p>{props.t('Streams.StreamsPurchase.priceText')}</p>
                                    <p>{currencySymbol} {streams[0].pricing.price}</p>
                                </button>
                            </span>
                        </span>
                        <p className={Styles.headDescr}>
                            {process.env.REACT_APP_STREAMS_DESCRIPTION}
                        </p>
                    </div>
                )}

                <div style={{ width: '100%' }}>
                    <Drawer anchor='right' open={showCheckout} onClose={() => { setShowCheckout(!showCheckout) }}
                        PaperProps={{
                            sx: {
                                backgroundColor: 'transparent',
                            }
                        }}
                    >
                        <div className={Styles.checkoutDrawer}>
                            <Checkout
                                purchaseEndpoint='/api/streams/purchase'
                                checkoutName='stream'
                                availableItems={streams}
                                onClose={() => setShowCheckout(false)}
                            />
                        </div>
                    </Drawer>
                </div>

                {loading ? (
                    <div>
                        <LoadingBackdrop isOpen={true} />
                    </div>
                ) : streams.length > 0 ? (
                    <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', }}>
                        {streams.map((lab) => (
                            <PurchaseCard
                                data={lab}
                                key={lab.id}
                                displayPrice={false}
                                interactive={false}
                            />

                        ))}
                    </div>
                ) : (
                    <div
                        style={{
                            paddingLeft: '22px',
                            display: "flex",
                            justifyContent: 'space-between'
                        }}
                    >
                        <p>{props.t('Streams.StreamsPurchase.message')}</p>
                        <a href='/streams' className={Styles.myLabsLink}>{props.t('Streams.StreamsPurchase.messageLink')}</a>
                    </div>
                )}
            </div>
        </>
    )
}